import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import { getIconTooltip } from "../tooltips";
import { ReactComponent as OkIcon } from "../../../../../assets/utils/images/svgs/Ok.svg";
import { ReactComponent as CrossIcon } from "../../../../../assets/utils/images/svgs/Cross.svg";
import { ReactComponent as OrangeExp } from "../../../../../assets/utils/images/svgs/OCircle.svg"
import { BsQuestionCircle } from "react-icons/bs";
import { FaLock } from "react-icons/fa6";

export default function IconCell({ cell, table }) {
 
  const value = cell.getValue();
  const hiddenColumns = table.options.meta?.hiddenColumns;
  const columnId = cell.column.id;
  // const isHidden = hiddenColumns && hiddenColumns.find((item) => item.id === columnId);
  // if (isHidden) return <div className="ignore"></div>;
  const ignoredColumn = hiddenColumns?.find(
  (item) => item.id === columnId
);

if (!ignoredColumn?.value) {
  return <div className="ignore"></div>;
}

  let node = null;
  let tipKey = value;
  switch (value) {
    case "locked":
      node = <FaLock color="#878EA6" />;
      tipKey = "LOCKED";
      break;
    case "+":
      node = <OkIcon />;
      break;
    case "-":
      node = <CrossIcon />;
      break;
    case "!":
      node = <BsQuestionCircle color="#FFA500" fontSize="15px" />;
      
    
      break;
    default:

      // return <>{value}</>;
      return <>{value === "" || value == null ? "--" : value}</>;
  }

  const tip = getIconTooltip(tipKey);

  return tip ? (
    <Tippy
      content={tip}
      placement="bottom"
      arrow
      className="custom-tooltip"
      appendTo={() => document.body}
      delay={[120, 0]}
    >
      <span role="img" aria-label={tip} className="d-inline-flex align-items-center">
        {node}
      </span>
    </Tippy>
  ) : (
    <span className="d-inline-flex align-items-center">{node}</span>
  );
}

